<footer class="lp-footer">
  <div class="d-flex">
    <div class="mr-auto">
      <span style="vertical-align: -webkit-baseline-middle"> 2021 - {{ currentYear }} © Live Agent | Knovvu </span>
      <br />
    </div>
  </div>
</footer>
